import { styled } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/DeleteRounded';

const styledIcon = IconComponent =>
    styled(IconComponent)({
        width: 18,
        height: 18,
        marginRight: 8,
        '& path': {
            fill: 'var(--text-secondary)',
        },
    });

export const StyledSaveIcon = styledIcon(SaveIcon);
export const StyledDeleteIcon = styledIcon(DeleteIcon);
